import { TOption } from '_shared';
import { FormSelectField } from 'components/form';
import { useSearchCountryByQuery } from 'hooks';
import { TCountry } from 'modules/cart/api';
import React from 'react';

const citiesToOptions = (countries: Array<TCountry>): Array<TOption> => {
  return countries.map((country: TCountry) => ({
    label: country.name,
    value: country.name,
  }));
};

export const CountryField = (): JSX.Element => {
  const [countries, handleInputChange] = useSearchCountryByQuery();

  return (
    <FormSelectField
      onInputChange={handleInputChange}
      isAutocomplete={false}
      label="Страна *"
      name="country"
      options={citiesToOptions(countries)}
      initValue={{
        label: 'Россия',
        value: 'Россия',
      }}
    />
  );
};
